export default "__VITE_ASSET__CFtEZd$K__"